import React from 'react';
import { Carousel, CarouselItem } from '../../carousel';
import { Video } from '../../video';
import { HeroCarouselWrapper, HeroCarouselInner } from '../styles/heroCarouselWrapper.style';
import StaticImageSlide from './staticImageSlide';
import ArticleSlide from './articleSlide';

const ARTICLE_SLIDE = 'ContentfulNewsArticle';
const IMAGE_SLIDE = 'ContentfulHeroPromo';
const VIDEO_SLIDE = 'ContentfulVideo';

/**
 * Renders a Carousel
 * @returns {object} Carousel Object
 */
class HeroCarousel extends React.Component {
  /**
   * Constructor
   * @param {object} props Incoming Props
   */
  constructor(props) {
    super(props);
    this.getSlideType = this.getSlideType.bind(this);
    this.pauseCarousel = this.pauseCarousel.bind(this);
    this.renderCarousel = this.renderCarousel.bind(this);
    this.state = {
      carouselPaused: false,
      currentSlide: 0,
    };
  }

  /**
 * Determines the slide tyoe an provides a component
 * @param {object} slide Slide to be checked
 * @param {index} index Slide index
 * @returns {XML} The corresponding Slide
 */
  getSlideType(slide, index) {
    const { currentSlide } = this.state;
    switch (slide.__typename) {
    case ARTICLE_SLIDE:
      return <ArticleSlide {...slide} />;
    case IMAGE_SLIDE:
      return <StaticImageSlide {...slide} />;
    case VIDEO_SLIDE:
      return (
        <Video
          hideOverlay
          fullBleed
          {...slide}
          pauseCarousel={this.pauseCarousel}
          isVideoOnScreen={currentSlide === index}
        />
      );
    default:
      return <div />;
    }
  }

  /**
   * Pauses Carousel
   */
  pauseCarousel() {
    this.setState({ carouselPaused: true });
  }

  /**
 * Gets all slides for a carousel
 * @param {array} slides All Possible Slides
 * @returns {XML} a list of slides
 */
  renderCarousel(slides) {
    const { carouselPaused } = this.state;
    if (slides.length === 1) {
      return (
        <HeroCarouselInner>
          {slides.map((slide, index) => (
            <CarouselItem key={`${slide.__typename}${index}`}>{this.getSlideType(slide, index)}</CarouselItem>
          ))}
        </HeroCarouselInner>
      );
    }

    /**
     * Update current slide index
     * @param {number} oldIndex old slide index
     * @param {number} newIndex new slide index
     */
    const onBeforeChange = (oldIndex, newIndex) => {
      this.setState({ currentSlide: newIndex });
    };

    return (
      <HeroCarouselInner>
        <Carousel
          noInfinite="true"
          auto
          tabletSlides={1}
          inScrollCount={1}
          numSlides={1}
          hideArrows
          dots
          pause={carouselPaused}
          beforeChange={onBeforeChange}
        >
          {slides.map((slide, index) => (
            <CarouselItem key={`${slide.__typename}${index}`}>{this.getSlideType(slide, index)}</CarouselItem>
          ))}
        </Carousel>
      </HeroCarouselInner>
    );
  }

  /**
   * Renders a hero, with a carousel if needed
   * @returns {XML} A video component
   */
  render() {
    const { carouselSlides } = this.props;
    let carousel = <div />;
    if (carouselSlides && carouselSlides.length > 0) {
      carousel = this.renderCarousel(carouselSlides);
    }
    return <HeroCarouselWrapper>{carousel}</HeroCarouselWrapper>;
  }
}

export default HeroCarousel;



// WEBPACK FOOTER //
// ./src/components/hero-carousel/components/heroCarousel.js